import NavigationComponent from "../../navigation/navigation.component";
import { Background, Header1, Header2, Image, ImageCard, ImageDiv, EmptySpace, Vid} from "./craftcreations.styles";
import C1 from '../../images/craft/C1.jpg';
import C2 from '../../images/craft/C2.jpg';
import C3 from '../../images/craft/C3.jpg';
import C4 from '../../images/craft/C4.jpg';
import V1 from '../../images/craft/nfc-heart.mp4';

const CraftCreations = () => {

    return(
        <Background>
            <NavigationComponent></NavigationComponent>
            <EmptySpace></EmptySpace>
            <Header1>Crotchet</Header1>
            
                <ImageCard>
                    <Header2>Blanket</Header2>
                    <Image src={C1} ></Image>
                </ImageCard>
                <ImageCard>
                    <Header2>Scarves</Header2>
                    <Image src={C2} ></Image>
                </ImageCard>
                <ImageCard>
                    <Header2>Paw Coaster</Header2>
                    <Image src={C3}></Image>
                </ImageCard>
                <ImageCard>
                    <Header2>Pot Holder</Header2>
                    <Image src={C4}></Image>
                </ImageCard>
                <ImageCard>
                    <Header2>Business Hearts</Header2>
                    <Image src={C4}></Image>
                </ImageCard>
                <ImageCard>
                    <Header2>Business Hearts</Header2>
                    <Vid controls src={V1} type="video/mp4"></Vid>
                </ImageCard>
    
        </Background>
    )
}

export default CraftCreations;